// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_k6-0";
export var buttonContainer = "_k6-3";
export var cancelButton = "_k6-4";
export var headerSection = "_k6-6";
export var headerTitle = "_k6-9";
export var messageSideLeft = "_k6-1";
export var messageSideRight = "_k6-2";
export var orderNumberContainer = "_k6-7";
export var orderNumberLabel = "_k6-8";
export var submitButton = "_k6-5";